import {useLazyQuery, gql} from "@apollo/client";
export const  BLOG_SEARCH = gql`
query BlogSearch($searchText: String = " ") {
  searchBlog(parameters: $searchText ){
    displayText
    htmlBody {
      html
    }
    bag {
      contentItems {
        ... on BlogImage {
          createdUtc
          displayText
          blogImageField {
            urls(first: 1)
          }
        }
      }
    }
    blogOverview {
      html
    }
    blogAuthor
    blogCreateDate
    alias {
      alias
    }
  }
}


`;

